"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuTxtLogo = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const serif = '"Merriweather","Linux Libertine",serif';
const slab = '"Roboto Slab",serif';
const MuTxtLogo = ({ size = 36, ...props }) => {
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "mutxt", ...props },
        React.createElement("g", { fill: "currentColor" },
            React.createElement("text", { x: 4.5, y: 30.6, fontFamily: serif, fontSize: 15.3, fontWeight: 400 }, 'μ'),
            React.createElement("text", { x: 11.6, y: 25.4, fontFamily: slab, fontSize: 22.5, fontWeight: 700 }, 't'),
            React.createElement("text", { x: 19, y: 30.5, fontFamily: slab, fontSize: 22.5, fontWeight: 700 }, 'x'),
            React.createElement("text", { x: 33.4, y: 35.35, fontFamily: slab, fontSize: 22.5, fontWeight: 700 }, 't'))));
};
exports.MuTxtLogo = MuTxtLogo;
exports.default = exports.MuTxtLogo;
